import { render, staticRenderFns } from "./app-document-failed.vue?vue&type=template&id=25574f46&"
import script from "./app-document-failed.vue?vue&type=script&lang=js&"
export * from "./app-document-failed.vue?vue&type=script&lang=js&"
import style0 from "./app-document-failed.vue?vue&type=style&index=0&id=25574f46&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports